import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@monorepo/shared-auth';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  return children;
};

export default ProtectedRoute;
